import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const giveawayAdsApi = createApi({
    reducerPath: "giveawayAds",
    baseQuery: createCustomFetchBaseQuery(),
    endpoints: (builder) => ({
        getGiveawayAds: builder.query({
            query: ({ page, limit, keyword, status }) => {
                let url = '/giveaway-ads'
                if (page) {
                    url += `?page=${page}`;
                }
                if (limit) {
                    url += `&limit=${limit}`;
                }
                if (keyword) {
                    url += `&keyword=${keyword}`;
                }
                if (status) {
                    url += `&status=${status}`;
                }

                return {
                    url,
                    method: "GET",
                }
            },
            transformResponse: (response) => ({
                data: response.data || [],
                meta: response.meta
            }),
        }),
        getGiveawayAdById: builder.query({
            query: (id) => ({
                url: `/giveaway-ads/${id}`,
                method: "GET",
            }),
        }),
        createGiveawayAd: builder.mutation({
            query: (data) => ({
                url: `/giveaway-ads`,
                method: "POST",
                body: data,
            }),
        }),
        updateGiveawayAd: builder.mutation({
            query: ({ id, data }) => ({
                url: `/giveaway-ads/${id}`,
                method: "PUT",
                body: data,
            }),
        }),
        deleteGiveawayAd: builder.mutation({
            query: (id) => ({
                url: `/giveaway-ads/${id}`,
                method: "DELETE",
            }),
        }),
        getGiveawayToCreateAd: builder.query({
            query: ({ page, limit, keyword, status }) => {
                let url = '/giveaway/ads'
                if (page) {
                    url += `?page=${page}`;
                }
                if (limit) {
                    url += `&limit=${limit}`;
                }
                if (keyword) {
                    url += `&keyword=${keyword}`;
                }
                if (status) {
                    url += `&status=${status}`;
                }

                return {
                    url,
                    method: "GET",
                }
            }
        }),
    }),
});



export const {
    useGetGiveawayAdsQuery,
    useGetGiveawayAdByIdQuery,
    useCreateGiveawayAdMutation,
    useUpdateGiveawayAdMutation,
    useDeleteGiveawayAdMutation,
    useGetGiveawayToCreateAdQuery
} = giveawayAdsApi;